import { render, staticRenderFns } from "./LinkDetail.vue?vue&type=template&id=63139127&scoped=true"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"
import style0 from "./LinkDetail.vue?vue&type=style&index=0&id=63139127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63139127",
  null
  
)

export default component.exports